import React from 'react';
import * as ContextTitle from '../../../constants/K007/ContextTitle';

/**
 * ContextMenuSlot
 */
class ContextMenuSlot extends React.Component {

  render() {
    const contextTitleArea = [];
    for (let i = 0; i < ContextTitle.CONTEXT_TITLE.length; i++) {
      const contextid = 'context' + i;
      contextTitleArea.push(
        <li className="section_context" id={contextid} key={i}>
          <a className="context_menu_a" href="" >{ContextTitle.CONTEXT_TITLE[i].name}</a>
        </li>
      );
    }

    return (
      <div id="context_menu">
        <ul>
          <li id="context_item_name" />
          {contextTitleArea}
        </ul>
      </div>
    );
  }
}

export default ContextMenuSlot;
